// @ts-nocheck

import { GET_PREBUILT_MACROS } from '../../actions/PrebuiltMacros/PrebuiltMacrosActions';
import { LOADING_STATUS } from '../../support/constants';
import { reducerWrapper } from '../../support/utils';
import type { AdPartnerPrebuiltMacros } from '../../types/prebuiltMacrosTypes';

export interface PrebuiltMacrosReducerType {
  loadingStatus: number;
  loading: boolean;
  error: any;
  prebuiltMacros: AdPartnerPrebuiltMacros;
}

const INIT_STATE: PrebuiltMacrosReducerType = {
  loadingStatus: LOADING_STATUS.INIT,
  loading: false,
  error: null,
  prebuiltMacros: {},
};

const handler = (state: PrebuiltMacrosReducerType, action) => {
  switch (action.type) {
    case GET_PREBUILT_MACROS.request:
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADING,
        loading: true,
        error: INIT_STATE.error,
        prebuiltMacros: INIT_STATE.prebuiltMacros,
      };
    case GET_PREBUILT_MACROS.response:
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
        prebuiltMacros: action.data,
      };
    case GET_PREBUILT_MACROS.error:
      return {
        ...state,
        loadingStatus: LOADING_STATUS.ERROR,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

const PrebuiltMacrosReducer = reducerWrapper(INIT_STATE, handler, {
  resetOn: ['APP_CHANGE'],
});

export default PrebuiltMacrosReducer;
